// Libs
import React from 'react';

// Components
import CountButton from '../../Button/CountButton';

// Hooks
import useSharedKitProducts from '../../../pages/Kits/hooks/useSharedKitProducts';

// Styles
import { useStyles } from './SharedKitProductQtyButtonsStyles';

const SharedKitProductQtyButtons = ({ product, nums, className }) => {
  const { classes, cx } = useStyles();
  const { addOne, removeOne, setCount } = useSharedKitProducts();

  return (
    <CountButton
      product={product}
      count={nums}
      limitValue={false}
      onAdd={() => addOne(product?.product_id)}
      onRemove={() => removeOne(product?.product_id)}
      onSetCount={(item, value) =>
        setCount(Math.round(value), item?.product_id)
      }
      className={cx(classes.countButton, className)}
    />
  );
};

export default SharedKitProductQtyButtons;
